
import { createGrid } from './utils';
import { visualiser } from './visualiser';


const enterLength = 1000;

class ModeLayer {
  constructor({addInteractionListener, addBeatListener}) {
    this.mode = null;
    this.addInteractionListener = addInteractionListener;
    this.addBeatListener = addBeatListener;
    this.time = 0;
  }
  switchTo(newMode, data) {
    this.time = 0;
    if (newMode) {
      this.mode = new newMode({
        ... this,
        ... data
      });
    } else {
      this.mode = null;
    }
  }
  name() {
    return this.mode?.constructor.name || null;
  }
  clear() { 
    this.switchTo(null);
  }
  update(delta, data) {
    this.time += delta;
    const enter = (this.time < enterLength) ? (this.time / enterLength) : null;
    this.mode?.update(delta, {
      enter,
      ...data
    });
  }
  getData() {
    return this.mode?.getData();
  }
}

export function modeManager({addInteractionListener, removeAllInteractionListeners, removeInteractionListener}) {

  const beatEventHandlers = [];
  function addBeatListener(handler) {
    beatEventHandlers.push(handler);
  }
  function removeInteractionListener(handler) {
    beatEventHandlers = beatEventHandlers.filter(h => h !== handler);
  }


  let layers = [];
  function layer(i) {
    if (!layers[i]) {
      layers[i] = new ModeLayer({addInteractionListener, removeAllInteractionListeners, addBeatListener});
    }
    return layers[i];

  }

  const audioEl = document.querySelector('.music');
  const debugEl = document.querySelector('.debug-log');

  let audioVis = null;
 
  function toggleMute(forcedStatus) {
    let isMuted = false;
    if (!audioVis) {
      audioVis = visualiser(audioEl);
    }
    if (forcedStatus !== false && audioVis.getData() === null) {
      audioVis.setup();
      audioEl.play();
    } else {
      isMuted = audioVis.toggleMute(forcedStatus);
    }
    return isMuted;

  }

  let currentBeat = 0;
  
  return {
    layer,
    update(delta) {

      const BPM = 120;
      const beatsPerSecond = BPM / 60;
      const currentTime = audioEl.currentTime;
      const currentTimeInBeats = ((currentTime/beatsPerSecond) * 4) - 0.5;
      const currentTimeInBeatsRounded = Math.round(currentTimeInBeats);

      let audioData = {};

      if (audioVis) {
        audioData = audioVis.getData();
        
        if (currentTimeInBeatsRounded !== currentBeat) {
          currentBeat = currentTimeInBeatsRounded;
          beatEventHandlers.forEach(handler => handler({
            currentTimeInBeatsRounded,
            currentTimeInBeats,
            major: (currentTimeInBeatsRounded + 2) % 4 === 0
          }));
        }
        
        // debugEl.innerText = `
        // beat: ${currentTimeInBeatsRounded}
        // layers: ${layers.map(l => l.name()).join(', ')}
        // 4 bars: ${16 - (currentTimeInBeatsRounded % 16)}
        // game won: ${window.__game_win}
        // `;
        
      }
      layers = layers.filter(l => l.mode);
      layers.forEach(l => l.update(delta, { audioData }));
    },
    getData() {
      const allLayerData = layers.map(l => l.getData());
      const mergedData = allLayerData.reduce(blendModes.intersect, createGrid());
      return mergedData;
    },
    getCurrentTime() {
      return audioEl.currentTime;
    },
    toggleMute,
    addBeatListener,
  }
}

const blendModes = {
  merge: (acc, curr) => {
    curr.forEach((value, i) => {
      if (value) {
        acc[i] = true;
      }
    });
    return acc;
  },
  intersect: (acc, curr) => {
    curr.forEach((value, i) => {
      acc[i] = value !== acc[i] && (value || acc[i]);
    });
    return acc;
  }
}
